import { Popover, MenuItem, Button } from '../ds/index.js'

// Non-drag "move this card to another column/stage" control for board cards.
// The trigger sits at the card's top-right; tapping it opens a menu of the
// other columns (a bottom sheet on phone). It's the tap fallback for touch
// drag-and-drop. All clicks/pointer events are isolated from the card so
// tapping the control never opens the record or starts a drag.
//
// Props:
//   open      — is this card's menu open (caller tracks which card is open)
//   onToggle  — toggle this card's menu
//   onClose   — close
//   columns   — [{ id, name, dot }] all columns/stages on the board
//   currentId — the card's current column/stage id (excluded from the list)
//   onMove    — (destId) => void, called when a destination is chosen
export default function CardMoveMenu({ open, onToggle, onClose, columns = [], currentId, onMove }) {
  const dests = columns.filter((c) => c.id !== currentId)
  return (
    <div
      className="cn-popover-wrap card-move"
      onClick={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
    >
      <Button
        variant="subtle"
        size="sm"
        className="card-move-trigger"
        title="Move to…"
        aria-label="Move to another column"
        onClick={(e) => { e.stopPropagation(); onToggle() }}
      >
        ⇄
      </Button>
      <Popover open={open} onClose={onClose} align="right">
        {dests.length === 0 ? (
          <MenuItem disabled>No other columns</MenuItem>
        ) : (
          dests.map((c) => (
            <MenuItem key={c.id} onClick={(e) => { e.stopPropagation(); onMove(c.id); onClose() }}>
              <span className="card-move-dot" style={{ background: c.dot || 'var(--color-muted)' }} />
              {c.name}
            </MenuItem>
          ))
        )}
      </Popover>
    </div>
  )
}
